<template>
    <div class="container-fluid">
        <div class="row mt-3">
            <div class="col-6 col-sm-6 col-md-6">
                <form @submit.prevent="submit" >
                    <div class="form-group" v-if="errors.length" >
                        <ul class="list-group">
                            <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
                        </ul>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Punkt</label>
                        <select class="form-control" v-model="form.storeId">
                            <option v-for="option in storesOptions" :key="option.id" v-bind:value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Utworzone przez</label>
                        <input class="form-control" type="text" v-model="form.createdBy" readonly>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Rodzaj usterki</label>
                        <select class="form-control" v-model="form.serviceReason">
                            <option v-for="option in reasonOptions" :key="option.id" v-bind:value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Model telefonu:</label>
                        <async-search-input
                            v-bind:uuid="asyncPhoneNameSearch"
                            v-model="form.phoneNameId"
                            v-bind:dataProvider="searchPhoneNamesProvider"
                            v-bind:dataMapper="searchPhoneNamesMapper"
                        />
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Cena dla klienta</label>
                        <input class="form-control" type="number" min="0" step="any" v-model="form.servicePrice"/>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Cena za serwis</label>
                        <input class="form-control" type="number" min="0" step="any" v-model="form.serviceRepairPrice"/>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Status</label>
                        <select class="form-control" v-model="form.serviceStatus">
                            <option v-for="option in serviceStatuses" :key="option.id" v-bind:value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Kontakt z klientem</label>
                        <input class="form-control" v-model="form.customerContact"/>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Opis</label>
                        <textarea class="form-control" v-model="form.comments"></textarea>
                    </div>
                    <div class="form-group input-group-sm">
                        <label >Data</label>
                        <datepicker 
                                class="mt-1 "
                                v-model="form.acceptanceDate"
                                :monday-first="true"
                                :language="lang"
                            ></datepicker>
                    </div>
                    <input class="btn btn-success torre-btn btn-sm mr-2" type="submit" value="Zapisz">
                    <router-link class="btn btn-secondary btn-sm mr-2" :to="{ name: 'servicesList' }">Anuluj</router-link>
                    <button class="btn btn-dark btn-sm" v-if="isAdmin" @click.prevent="deleteServiceConfirm()">Usuń</button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import {pl} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import alertify from 'alertifyjs';
import un from 'underscore'
import ServicesManager from "@/components/service/ServicesManager"

const servicesManager = new ServicesManager()

export default {
    components: {
      datepicker 
    },
    name: "ServicesEdit",
    data: () => {
        return {
            asyncPhoneNameSearch: "asyncPhoneNameSearch",
            searchPhoneNamesProvider: servicesManager.searchPhoneNames,
            searchPhoneNamesMapper: servicesManager.searchPhoneNamesMapper,
            lang: pl,
            storesOptions: [],
            reasonOptions: [],
            errors: [],
            serviceStatuses: servicesManager.serviceStatuses(),
            form: {
                serviceId: -1,
                storeId: -1,
                phoneNameId: "-1",
                createdBy: "",
                serviceReason: "-1",
                customerContact: "",
                acceptanceDate: moment().format("YYYY-MM-DD"),
                servicePrice: "",
                comments: "",
                serviceStatus: "",
                serviceRepairPrice: ""
            }
        }
    },
    computed: {
        isAdmin() {
            return servicesManager.isAdmin()
        }
    },
    created() {
        this.loadConfig()
        this.initStoresOptions()
        this.loadService()
    },
    methods: {
        deleteServiceConfirm() {
            const that = this
            alertify.confirm('', 'Chcesz usunąć telefon?', function(){
                that.deleteService()
                }, function(){},
            );
        },
        deleteService() {
            const id = this.$route.params.id
            servicesManager.deleteService(id, this.onDeleteSuccess, this.onDeleteError)
        },
        onDeleteSuccess(data) {
            this.$router.push({name: 'servicesList'})
            alertify.set('notifier','position', 'top-center');
            alertify.success("Telefon został usunięty").delay(3);
        },
        onDeleteError(err) {
            console.log(err)
            this.errors = err
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można usunąć telefonu.").delay(3);
        },
        submit() {
            this.clearErrors()
            servicesManager.updateService(this.form, this.onUpdateSuccess, this.onUpdateError)
        },
        onUpdateSuccess(data) {
            this.$router.push({name: 'servicesList'})
            alertify.set('notifier','position', 'top-center');
            alertify.success("Serwis został zapisany").delay(3);
        },
        onUpdateError(err) {
            console.log(err)
            this.errors = err
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie zedytować dodać serwisu.").delay(3);
        },
        loadService() {
            servicesManager.loadService(this.$route.params.id, this.onLoadServiceSuccess, this.onLoadServiceError)
        },
        onLoadServiceSuccess(data) {
            this.form.serviceId = data.id
            this.form.acceptanceDate = data.acceptanceDate
            this.form.comments = data.comments
            this.form.customerContact = data.customerContact
            this.form.servicePrice = data.servicePrice
            this.form.createdBy = data.createdBy
            this.form.serviceReason = data.serviceReason.id
            this.form.storeId = data.store.id
            this.form.serviceRepairPrice = data.serviceRepairPrice
            this.form.serviceStatus = data.serviceStatus
            this.$emit("setAsyncSearchInputData", {...data.phone,...{uuid:this.asyncPhoneNameSearch}})
        },
        onLoadServiceError(err) {
            this.$router.push({name: 'servicesList'})
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można pobrać serwisu.").delay(3);
        },
        initStoresOptions() {
            servicesManager.initStores(this.onStoresSuccess)
        },
        onStoresSuccess(data, selectedStoreId) {
            this.storesOptions = data
            this.form.storeId = selectedStoreId
        },
        clearErrors() {
            this.errors = []
        },
        loadConfig() {
            servicesManager.loadConfig(this.onConfigSuccess, this.onConfigError)
        },
        onConfigSuccess(data) {
            this.reasonOptions = this.initReasons(data.reasons)
        },
        onConfigError(err) {
            console.log(err)
        },
        initReasons(options) {
            const finalList = []
            const defaultOption = {
                id: "-1",
                name: "wybierz opcję"
            }
            finalList.push(defaultOption)
            for (var i in options) {
                var item = options[i]
                finalList.push({
                    id: item.key,
                    name: item.value
                })
            }
            return finalList
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/service/ServicesEdit.vue